import { Component, Inject, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { StaggeredProductDetailsDtoResponse } from 'app/core/models/staggered-product-details.dto-response';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Constants } from '../../core/Constants';
import { BRAND } from '../../core/DI';
import { ImageDetails } from '../../core/models/image-details.dto-response';
import { MakeYearModel } from '../../core/models/make-year-model.model';
import { PackageBuilderSummaryProduct } from '../../core/models/package-builder-summary-product.model';
import { ProductDetailsModel } from '../../core/models/product-details-model.model';
import { ProductDetailsDtoResponse } from '../../core/models/product-details.dto-response';
import { Product } from '../../core/models/product.model';
import { RouteContext } from '../../core/models/route-context';
import { User } from '../../core/User';
import { Helper } from '../../shared/helper';
import { IProductService } from '../../shared/iproduct.service';
import { ProductZoomService } from '../../shared/notes/product-zoom.service';
import { NormalizeQtyPipe } from '../../shared/pipe/normalize-qty.pipe';
import { WheelService } from '../../shared/wheel.service';
import { ProductDetailsBaseComponent } from '../product-details.base-component';
import { SkuList } from 'app/core/models/sku-list';
import { FilterService } from '../../shared/filter.service';
import { GenericSummaryCardDtoResponse } from 'app/core/models/generic-summary-card.dto-response';
import { ProductDetailFilter } from 'app/core/models/product-card-detail.dto-response';

@Component({
  selector: 'app-product-details-scrollable',
  templateUrl: './product-details-scrollable.component.html',
  styleUrls: ['./product-details-scrollable.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ProductDetailsScrollableComponent extends ProductDetailsBaseComponent implements OnInit, OnDestroy {
  showWaiting: boolean;
  productService: IProductService;
  productType: string;
  currentImage: string;
  currentImageMailToURL: string;
  imageList: string[] = [];
  backLink: string;
  eachText: string;
  isInPackageBuilder: boolean;
  isByVehicle: boolean;
  context: RouteContext = RouteContext.NONE;
  productModel: ProductDetailsModel = null;
  rearProductModel: ProductDetailsModel = null;
  isInB2b: boolean;
  brand: string;
  wheelType: boolean;
  safeURL: SafeUrl;
  regexp: RegExp;
  displayConfigurator = false;
  mym: MakeYearModel;
  brandLogoURL: string;
  winterContext = false;
  //longSKU: string;
  //rearLongSKU: string = null;
  errorMessage: string;
  subs: Subscription[] = [];
  public modalInstance;
  closeResult: string;
  productList: GenericSummaryCardDtoResponse[];
  selectedFilters: ProductDetailFilter[];
  selectedRearFilters: ProductDetailFilter[];
  //gridSkuList: GenericSummaryCardDtoResponse[];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private filterService: FilterService,
    private modalService: NgbModal,
    private productZoomService: ProductZoomService,
    private sanitizer: DomSanitizer,

    @Inject(BRAND) brand: string) {
    super();
    this.brand = brand;
    this.isInB2b = brand === Constants.BRAND_B2B;
    this.winterContext = route.snapshot.queryParams['season'] === "winter";
  }

  ngOnInit(): void {
    this.showWaiting = true;
    this.regexp = new RegExp(Constants.ICONFIGURATOR_REGEX);

    //this.route.data.take(1).subscribe(data => {
    this.subs.push(this.route.data.pipe(take(1)).subscribe(data => {
      this.productType = data.productType;
      this.backLink = `FC.Display${data.productType}Details.BackToSearch`;
      this.eachText = `FC.Display${data.productType}Details.Each`;
      this.context = data.context;
      this.isInPackageBuilder = this.context === RouteContext.PACKAGE_BUILDER;
      this.isByVehicle = this.context === RouteContext.SEARCH_BY_VEHICLE;
      this.setupProductService();
    }, Helper.handleError));

    this.subs.push(this.route.queryParamMap.subscribe(queryParams => {
      if (this.context === RouteContext.PACKAGE_BUILDER || this.context === RouteContext.SEARCH_BY_VEHICLE ||
        this.context === RouteContext.SEARCH_BY_VEHICLE_FOR_ACCESSORY) {
        this.mym = Helper.extractMakeYearModelFromRouteParam(queryParams);
        const wheelStagger = Helper.extractWheelStaggerFromRouteParam(queryParams);
        let categoryFiltersDto = this.filterService.convertCategoryFiltersDtoFromURL(queryParams);
        categoryFiltersDto.paging.pageSize = 1000;

        this.subs.push(this.productService.getProductDetailsByVehicleAndFilterAndStyleAndFinish(this.mym, wheelStagger, categoryFiltersDto).subscribe(
          responseProduct => {
            if (responseProduct !== null) {
              this.productList = responseProduct;
              if (this.productList[0].frontProduct != null) {
                this.setupFrontModel(this.productList[0]);
                this.selectedFilters = new Array<ProductDetailFilter>();
                let filter = new ProductDetailFilter();
                filter.label = "FC.ProductDetail.Label.Size";
                filter.value = this.productModel.product.details.find(d => d.label === "FC.ProductDetail.Label.Size").value;
                this.selectedFilters.push(filter);
              }
              if (this.productList[0].rearProduct != null) {
                this.setupRearModel(this.productList[0]);
                this.selectedRearFilters = new Array<ProductDetailFilter>();
                let filter = new ProductDetailFilter();
                filter.label = "FC.ProductDetail.Label.Size";
                filter.value = this.rearProductModel.product.details.find(d => d.label === "FC.ProductDetail.Label.Size").value;
                this.selectedRearFilters.push(filter);
               }
              this.showWaiting = false;

              //this.gridSkuList = (JSON.parse(sessionStorage.getItem("prodRes")));
              //this.gridSkuList.forEach.
              //Helper.SkuList = new SkuList(this.gridSkuList);
              //Helper.log(Helper.SkuList.canMoveNext.toString());
              Helper.SkuList = new SkuList(responseProduct);

              //responseProduct.forEach(prod => {
              //  super.addSkuToDetails(prod.frontProduct);
              //  if (prod.rearProduct)
              //    super.addSkuToDetails(prod.rearProduct);
              //});

              //if (responseProduct[0].rearProduct)
              //  this.changeSku(responseProduct[0].frontProduct.pairNo);
              //else
              //  this.changeSku(responseProduct[0].frontProduct.longSKU);
            } else {
              this.showWaiting = false;
              this.errorMessage = 'FC.ProductDetail.Error';
            }
          }, Helper.handleError));
      } else {// if (this.context === RouteContext.WHEELS_BY_SPEC) {
        //this.getProductDetailsBySpecs();
      }

    }, Helper.handleError));
  }

  setupProductService(): void {
    switch (this.productType) {
      case Constants.PRODUCT_TYPE_WHEEL:
        this.productService = this.injector.get<WheelService>(WheelService);
        this.wheelType = true;
        break;
    }
  }

  //getProductDetails(): void {
  //  this.showWaiting = true;
  //  this.displayConfigurator = false;
  //  this.productModel = new ProductDetailsModel();
  //  this.productModel.id = this.longSKU;

  //  if (this.rearLongSKU !== null) {
  //    this.rearProductModel = new ProductDetailsModel();
  //    this.rearProductModel.id = this.rearLongSKU;
  //  }

  //  if (this.mym.isValid) {
  //    if (this.rearProductModel) {
  //      this.subs.push(this.productService.getStaggeredProductDetails(`${this.productModel.id}_${this.rearProductModel.id}`, this.mym, '', '').subscribe(
  //        responseProduct => {
  //          if (responseProduct === null) {
  //            this.rejectProduct();
  //            return;
  //          }
  //          this.setupStaggeredProduct(responseProduct);
  //        }, Helper.handleError));
  //    } else {
  //      this.subs.push(this.productService.getProductDetails(this.productModel.id, this.mym, '', '').subscribe(
  //        responseProduct => {
  //          if (responseProduct === null) {
  //            this.rejectProduct();
  //            return;
  //          }
  //          this.setupProduct(responseProduct);
  //        }, Helper.handleError));
  //    }
  //  } else {
  //    this.subs.push(this.productService.getProductDetailsBySpecs(this.productModel.id).subscribe(
  //      responseProduct => {
  //        if (responseProduct === null) {
  //          this.rejectProduct();
  //          return;
  //        }
  //        this.setupProduct(responseProduct);
  //      }, Helper.handleError));
  //  }
  //}

  rejectProduct() {
    // alert("no data available for id: " + this.productModel.id);
    this.showWaiting = false;
  }

  //setupProduct(responseProduct: ProductDetailsDtoResponse): void {
  //  //super.addSkuToDetails(responseProduct);
  //  this.productModel.product = responseProduct;
  //  this.getImageList(this.productModel.product);
  //  this.brandLogoURL = Helper.getLogoURL(this.productModel.product.productType, this.productModel.product.productBrand);
  //  this.setupConfigurator(responseProduct.iconUrl);
  //  this.showWaiting = false;
  //}

  //setupStaggeredProduct(responseProduct: StaggeredProductDetailsDtoResponse): void {
  //  //super.addSkuToDetails(responseProduct.frontProductDetailsDto);
  //  //super.addSkuToDetails(responseProduct.rearProductDetailsDto);

  //  this.productModel.product = responseProduct.frontProductDetailsDto;
  //  this.rearProductModel.product = responseProduct.rearProductDetailsDto;

  //  this.getImageList(this.productModel.product);
  //  this.brandLogoURL = Helper.getLogoURL(this.productModel.product.productType, this.productModel.product.productBrand);
  //  this.setupConfigurator(responseProduct.frontProductDetailsDto.iconUrl);
  //  this.showWaiting = false;
  //}

  goUp() {
    let routerNavParam: NavigationExtras = { relativeTo: this.route, queryParamsHandling: "preserve" };

    if (!this.isInB2b) {
      const params: any = this.route.snapshot.queryParams;
      if (params && params.searchtext && params.productStatus) 
        routerNavParam = { relativeTo: this.route, queryParams: { 'productStatus': null, }, queryParamsHandling: 'merge' };
    }
    
    this.router.navigate([".."], routerNavParam);
  }

  changeImage(imgLink: string) {
    this.currentImage = imgLink;
    const subject = encodeURI(`Fastco Canada | ${this.productModel.product.productBrand} ${this.productModel.product.longSKU}`);
    this.currentImageMailToURL = `mailto:?subject${subject}=&body=${imgLink}`;
  }

  getAllIcons(): ImageDetails[] {
    if (this.productModel)
      return Helper.removeImageDuplicates(this.productModel.product.icons);
    return [];
  }

  getImageList(product: ProductDetailsDtoResponse): void {
    if (product !== null && product !== undefined) {
      this.imageList = product.productImages.map(pi => pi.imageUrl); //mike
      //this.imageList = product.productImages.map(pi => pi.thumbnailUrl); //mike
      if (this.imageList.length > 0) {
        this.currentImage = this.imageList[0];
        const subject = encodeURI(`Fastco Canada | ${this.productModel.product.productBrand} ${this.productModel.product.longSKU}`);
        this.currentImageMailToURL = `mailto:?subject=${subject}&body=${this.imageList[0]}`;
      }
    }
  }

  goToFindADealer() {
    // djb: href used to go to old page, find tfs #
    window.location.href = `/${this.brand.replace(' ', '-')}${Constants.FIND_A_DEALER_LINK}`;
  }

  getValue(product: ProductDetailsDtoResponse, label: string) {
    if (product && product.details.some(d => d.label === label))
      return product.details.find(d => d.label === label).value;
    return 'N/A';
  }

  getBrand() {
    if (this.productModel)
      return this.productModel.product.productBrand;
    return "";
  }

  getTitle() {
    if (this.productModel) {
      if (this.rearProductModel)
        return `${this.productModel.product.title} / ${this.rearProductModel.product.title}`;
      return this.productModel.product.title;
    }
    return "";
  }

  openProductZoomDialog(): void {
    this.productZoomService.showProductZoom(this.currentImage, 'FC.ProductWarningsNotes.Continue', 'pb-product-zoom');
  }

  setupConfigurator(iconUrl: string) {
    if (iconUrl) {
      // Check if iconUrl matches iconfigurator regexp for security reasons
      if (this.regexp.test(iconUrl)) {
        const iconfiguratorParameter = iconUrl.substring(iconUrl.indexOf(Constants.ICONFIGURATOR_PAGE));
        let replacedUrl = window.location.protocol + '//';
        if (window.location.hostname.indexOf('localhost') > -1) {
          // djb:domain required by iconfigurator product key
          replacedUrl += "b2bdev.fastco.ca";
        } else {
          // djb:host includes port number
          //replacedUrl += window.location.hostname;
          replacedUrl += window.location.host;
        }
        replacedUrl += Constants.ICONFIGURATOR_LOCATION + iconfiguratorParameter;
        //replacedUrl needs to be modified to show color scroll.
        this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(replacedUrl);
      }
    }
  }

  open(content) {
    //this.showWaiting = true;

    this.modalInstance = this.modalService.open(content, { windowClass: 'modal-opened product-configurator-modal' });

    this.modalInstance.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      //alert(this.closeResult);
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //alert(this.closeResult);
    });

    //this.showWaiting = false;
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  } 

  get showRetailPrice(): boolean {
    return User.showRetailPrice || User.permissionType === "|customer";
  }

  get showDealerPrice(): boolean {
    return User.showDealerPrice;
  }

  get showInventory(): boolean {
    return User.showInventory;
  }

  get showCalgaryInventory(): boolean {
    let show: boolean = false;
    if (this.productModel.product.inventory.onHandQtyCal != null) {
      show = true;
    }
    else if (this.productModel.product.inventory.inTransitQtyCal != null) {
      show = true;
    }
    return show;
  }

  get showIsNew(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return (this.productModel.product.isNew && !this.productModel.product.isSpecial) || (this.rearProductModel.product.isNew && !this.rearProductModel.product.isSpecial);
      return this.productModel.product.isNew && !this.productModel.product.isSpecial;
    }
    return false;
  }

  get showIsSpecial(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return (this.productModel.product.isSpecial || this.rearProductModel.product.isSpecial);
      return this.productModel.product.isSpecial;
    }
    return false;
  }

  get showIsDirectFit(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return this.productModel.product.isDirectFit && this.rearProductModel.product.isDirectFit;
      return this.productModel.product.isDirectFit;
    }
    return false;
  }

  get showIsAggressiveFitment(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return (this.productModel.product.isAggressiveFitment || this.rearProductModel.product.isAggressiveFitment);
      return this.productModel.product.isAggressiveFitment;
    }
    return false;
  }

  get showIsDrilled(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return (this.productModel.product.isDrilled || this.rearProductModel.product.isDrilled);
      return this.productModel.product.isDrilled;
    }
    return false;
  }

  get showIsBlem(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return (this.productModel.product.isBlem || this.rearProductModel.product.isBlem);
      return this.productModel.product.isBlem;
    }
    return false;
  }

  get showConfirmedFitment(): boolean {
    if (this.productModel) {
      if (this.rearProductModel)
        return this.productModel.product.confirmedFitment && this.rearProductModel.product.confirmedFitment;
      return this.productModel.product.confirmedFitment;
    }
    return false;
  }

  showDropDownList(detailLabel: string): boolean {
    if (detailLabel === "FC.ProductDetail.Label.Size" ||
      detailLabel === "FC.ProductDetail.Label.PCD" ||
      detailLabel === "FC.ProductDetail.Label.Offset" ||
      detailLabel === "FC.ProductDetail.Label.Bore" ||
      detailLabel === "FC.ProductDetail.Label.Seat") {
      var values = this.getDropDownList(detailLabel);
      const show = values != null && values.length > 1;
      if (show) {
        if (!this.selectedFilters.some(f => f.label === detailLabel)) {
          let filter = new ProductDetailFilter();
          filter.label = detailLabel;
          filter.value = this.productModel.product.details.find(d => d.label === detailLabel).value;
          this.selectedFilters.push(filter);
        }
      }
      return show;
    }
    return false;
  }

  showRearDropDownList(detailLabel: string): boolean {
    if (detailLabel === "FC.ProductDetail.Label.Size" ||
      detailLabel === "FC.ProductDetail.Label.PCD" ||
      detailLabel === "FC.ProductDetail.Label.Offset" ||
      detailLabel === "FC.ProductDetail.Label.Bore" ||
      detailLabel === "FC.ProductDetail.Label.Seat") {
      var values = this.getRearDropDownList(detailLabel);
      const show = values != null && values.length > 1;
      if (show) {
        if (!this.selectedRearFilters.some(f => f.label === detailLabel)) {
          let filter = new ProductDetailFilter();
          filter.label = detailLabel;
          filter.value = this.rearProductModel.product.details.find(d => d.label === detailLabel).value;
          this.selectedRearFilters.push(filter);
        }
      }
      return show;
    }
    return false;
  }

  getDropDownList(detailLabel: string): string[] {
    if (detailLabel === "FC.ProductDetail.Label.Size") {
      return Array.from(new Set(this.productList.map(p => p.frontProduct.details.details.find(d => d.label === detailLabel).value).sort((a, b) => a.localeCompare(b))));
    }
    else {
      const candidates = this.productList.filter(p => {
        let match = true;
        this.selectedFilters.forEach(f => {
          const skip = (detailLabel === "FC.ProductDetail.Label.PCD" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Offset" || f.label === "FC.ProductDetail.Label.Bore" || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Offset" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Bore" || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Bore" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Seat" && f.label === detailLabel);
          if (!skip)
            match = match && p.frontProduct.details.details.some(d => d.label === f.label && d.value === f.value);
        });
        return match;
      });
      return Array.from(new Set(candidates.map(p => p.frontProduct.details.details.find(d => d.label === detailLabel).value).sort((a, b) => a.localeCompare(b))));
   }
  }

  getRearDropDownList(detailLabel: string): string[] {
    if (detailLabel === "FC.ProductDetail.Label.Size") {
      return Array.from(new Set(this.productList.map(p => p.rearProduct.details.details.find(d => d.label === detailLabel).value).sort((a, b) => a.localeCompare(b))));
    }
    else {
      const candidates = this.productList.filter(p => {
        let match = true;
        this.selectedRearFilters.forEach(f => {
          const skip = (detailLabel === "FC.ProductDetail.Label.PCD" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Offset" || f.label === "FC.ProductDetail.Label.Bore" || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Offset" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Bore" || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Bore" && (f.label === detailLabel || f.label === "FC.ProductDetail.Label.Seat")) ||
                        (detailLabel === "FC.ProductDetail.Label.Seat" && f.label === detailLabel);
          if (!skip)
            match = match && p.rearProduct.details.details.some(d => d.label === f.label && d.value === f.value);
        });
        return match;
      });
      return Array.from(new Set(candidates.map(p => p.rearProduct.details.details.find(d => d.label === detailLabel).value).sort((a, b) => a.localeCompare(b))));
    }
  }

  selectionChanged(event) {
    if (this.selectedFilters == null)
      this.selectedFilters = new Array<ProductDetailFilter>();
    if (this.selectedFilters.some(f => f.label === event.target.dataset.label)) {
      this.selectedFilters.find(f => f.label === event.target.dataset.label).value = event.target.value;
      if (event.target.dataset.label === "FC.ProductDetail.Label.Size") {
        this.selectedFilters = this.selectedFilters.filter(f => f.label === "FC.ProductDetail.Label.Size");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.PCD") {
        this.selectedFilters = this.selectedFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                f.label === "FC.ProductDetail.Label.PCD");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.Offset") {
        this.selectedFilters = this.selectedFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                f.label === "FC.ProductDetail.Label.PCD" ||
                                                                f.label === "FC.ProductDetail.Label.Offset");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.Bore") {
        this.selectedFilters = this.selectedFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                f.label === "FC.ProductDetail.Label.PCD" ||
                                                                f.label === "FC.ProductDetail.Label.Offset" ||
                                                                f.label === "FC.ProductDetail.Label.Bore");
      }
    }
    else {
      const detail = new ProductDetailFilter();
      detail.label = event.target.dataset.label;
      detail.value = event.target.value;
      this.selectedFilters.push(detail);
    }
    this.applyFilters();
  }

  rearSelectionChanged(event) {
    if (this.selectedRearFilters == null)
      this.selectedRearFilters = new Array<ProductDetailFilter>();
    if (this.selectedRearFilters.some(f => f.label === event.target.dataset.label)) {
      this.selectedRearFilters.find(f => f.label === event.target.dataset.label).value = event.target.value;
      if (event.target.dataset.label === "FC.ProductDetail.Label.Size") {
        this.selectedRearFilters = this.selectedRearFilters.filter(f => f.label === "FC.ProductDetail.Label.Size");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.PCD") {
        this.selectedRearFilters = this.selectedRearFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                        f.label === "FC.ProductDetail.Label.PCD");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.Offset") {
        this.selectedRearFilters = this.selectedRearFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                        f.label === "FC.ProductDetail.Label.PCD" ||
                                                                        f.label === "FC.ProductDetail.Label.Offset");
      } else if (event.target.dataset.label === "FC.ProductDetail.Label.Bore") {
        this.selectedRearFilters = this.selectedRearFilters.filter(f => f.label === "FC.ProductDetail.Label.Size" ||
                                                                        f.label === "FC.ProductDetail.Label.PCD" ||
                                                                        f.label === "FC.ProductDetail.Label.Offset" ||
                                                                        f.label === "FC.ProductDetail.Label.Bore");
      }
    }
    else {
      const detail = new ProductDetailFilter();
      detail.label = event.target.dataset.label;
      detail.value = event.target.value;
      this.selectedRearFilters.push(detail);
    }
    this.applyFilters();
  }

  applyFilters() {
    if (this.productList[0].rearProduct != null) {
      const candidates = this.productList.filter(p => {
        let match = true;
        this.selectedFilters.forEach(f => {
          match = match && p.frontProduct.details.details.some(d => d.label === f.label && d.value === f.value);
        });
        this.selectedRearFilters.forEach(f => {
          match = match && p.rearProduct.details.details.some(d => d.label === f.label && d.value === f.value);
        });
        return match;
      });

      if (candidates.length > 0) {
        // take the lowest price and lightest weight front wheel to display
        // jl: To do: maybe use combined front and rear values
        var candidate = candidates.sort((a, b) => {
          const aRetailPrice = Number.parseFloat(a.frontProduct.retailPrice);
          const bRetailPrice = Number.parseFloat(b.frontProduct.retailPrice);
          if (aRetailPrice === bRetailPrice) {
            const aWeight = Number.parseFloat(a.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Weight").value.replace("lbs", "").trim());
            const bWeight = Number.parseFloat(b.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Weight").value.replace("lbs", "").trim());
            return bWeight - aWeight;
          }
          return bRetailPrice - aRetailPrice;
        })[0];
        this.setupFrontModel(candidate);
        this.setupRearModel(candidate);
      }
    }
    else {
      const candidates = this.productList.filter(p => {
        let match = true;
        this.selectedFilters.forEach(f => {
          match = match && p.frontProduct.details.details.some(d => d.label === f.label && d.value === f.value);
        });
        return match;
      });

      if (candidates.length > 0) {
        // take the lowest price and lightest weight wheel to display
        var candidate = candidates.sort((a, b) => {
          const aRetailPrice = Number.parseFloat(a.frontProduct.retailPrice);
          const bRetailPrice = Number.parseFloat(b.frontProduct.retailPrice);
          if (aRetailPrice === bRetailPrice) {
            const aWeight = Number.parseFloat(a.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Weight").value.replace("lbs", "").trim());
            const bWeight = Number.parseFloat(b.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Weight").value.replace("lbs", "").trim());
            return bWeight - aWeight;
          }
          return bRetailPrice - aRetailPrice;
        })[0];
        this.setupFrontModel(candidate);
      }
    }
  }

  setupFrontModel(card: GenericSummaryCardDtoResponse) {
    this.productModel = new ProductDetailsModel();
    this.productModel.id = card.frontProduct.longSKU;
    this.productModel.product = Helper.convertToProductDetailsDtoResponse(card.frontProduct, this.productType, this.brand, null);

    this.getImageList(this.productModel.product);
    this.brandLogoURL = Helper.getLogoURL(this.productModel.product.productType, this.productModel.product.productBrand);
    this.setupConfigurator(this.productModel.product.iconUrl);
  }

  setupRearModel(card: GenericSummaryCardDtoResponse) {
    this.rearProductModel = new ProductDetailsModel();
    this.rearProductModel.id = card.rearProduct.longSKU;
    this.rearProductModel.product = Helper.convertToProductDetailsDtoResponse(card.rearProduct, this.productType, this.brand, null);
  }

  changeSku(sku: string) {
    //if (sku.indexOf("_") > 0) {
    //  this.longSKU = sku.substring(0, sku.indexOf("_"));
    //  this.rearLongSKU = sku.substring(sku.indexOf("_") + 1);
    //} else
    //  this.longSKU = sku;
    Helper.SkuList.setIndex(sku);
    //this.getProductDetails();
  }

  get canMovePrev(): boolean {
    return Helper.SkuList.canMovePrev;
  }

  movePrev(source: string): void {
    Helper.log(`${source} movePrev(left) `);
    if (this.canMovePrev) {
      this.changeSku(Helper.SkuList.prev);
    }
  }

  get canMoveNext(): boolean {
    return Helper.SkuList.canMoveNext;
  }

  moveNext(source: string): void {
    Helper.log(`${source}: moveNext(right)`);
    if (this.canMoveNext) {
      this.changeSku(Helper.SkuList.next);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}
